import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { getContext } from '@fiverr-private/fiverr_context';
import type { ListingFlow, UserData } from '@fiverr-private/listing_types';
import { LISTING_FLOWS, PRO_LISTING_FLOWS } from '@fiverr-private/dm_brief_creation';
import { EXPERIMENTS } from '@fiverr-private/listing_experiments';
import { INCLUDED_LEAF_IDS } from '../../experiments/crowsMpBffExpansion/constants';
import { MAX_ITEMS_TO_SHOW_NO_RESULTS } from '../../constants';
import { EXCLUDED_SELLERS_COUNTRIES_CODES } from './constants';

export interface UseInBriefFloatingFormPreConditionsArgs {
    flow: ListingFlow;
    userType: UserData['userType'];
    isExpertListings: boolean;
    resultsCount: number;
    leafId: number;
}

export const useInBriefFloatingFormPreConditions = ({
    flow,
    userType,
    isExpertListings,
    resultsCount,
    leafId,
}: UseInBriefFloatingFormPreConditionsArgs): boolean => {
    const {
        userId,
        experience: { isBusiness },
        isMobile,
        locale,
        countryCode,
        abTests,
    } = getContext();

    const inCrowsMpBffExpansionExperiment = !isBusiness && Number(abTests[EXPERIMENTS.CROWS_MP_BFF_EXPANSION]) === 2;

    const hasFewResults = isExpertListings ? resultsCount < MAX_ITEMS_TO_SHOW_NO_RESULTS : resultsCount === 0;
    const businessCondition = inCrowsMpBffExpansionExperiment ? true : isBusiness;
    const userTypeCondition = inCrowsMpBffExpansionExperiment
        ? userType !== 'REGISTERED_NOT_CONVERTED'
        : userType === 'REPEAT_BUYER';
    const leafIdCondition = inCrowsMpBffExpansionExperiment ? INCLUDED_LEAF_IDS.includes(leafId) : true;
    const flowCondition = ((inCrowsMpBffExpansionExperiment ? LISTING_FLOWS : PRO_LISTING_FLOWS) as string[]).includes(
        flow
    );

    return (
        !!userId &&
        !isMobile &&
        locale === DEFAULT_FIVERR_LOCALE &&
        !EXCLUDED_SELLERS_COUNTRIES_CODES.includes(countryCode) &&
        !hasFewResults &&
        businessCondition &&
        userTypeCondition &&
        leafIdCondition &&
        flowCondition
    );
};
